module.exports = __webpack_public_path__ + "assets/img/BUSINESS PARKS BROCHURE.ecca7002.png";